<script lang="ts">
  import { Button } from "@/lib/components/ui/button";

  // bind to this value to get/set the current page
  export let currentPage: number = 1;
  export let totalPages: number = 1;

  function getPageNumbers(currentPage, totalPages) {
    let startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, startPage + 4);
    startPage = Math.max(1, endPage - 4); // Adjust startPage if near the end
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers;
  }
  
</script>

<Button variant='ghost' size='icon' on:click={() => currentPage > 1 ? --currentPage : null} disabled={currentPage <= 1}>
    <i class='fa-thin fa-xl fa-chevron-left' aria-hidden='true'/>
</Button>
{#each getPageNumbers(currentPage, totalPages) as page}
  <Button variant={page === currentPage ? 'outline' : 'ghost'} size='icon' on:click={() => currentPage = page}>{page}</Button>
{/each}
<Button variant='ghost' size='icon' on:click={() => currentPage < totalPages ? ++currentPage : null} disabled={currentPage >= totalPages}>
    <i class='fa-thin fa-xl fa-chevron-right' aria-hidden='true'/>
</Button>
